<div data-id="range-picker" class="range-picker-calendar d-flex flex-column">
  <div class="d-flex">
    @for (day of daysOfWeek; track day; let first = $first) {
      <div class="d-flex align-items-center justify-content-center" [class.padding]="!first">
        <div
          data-id="range-picker-week-day"
          class="d-flex align-items-center justify-content-center range-picker-calendar-cell"
        >
          <p>{{ day }}</p>
        </div>
      </div>
    }
  </div>
  <div class="d-flex flex-wrap">
    @for (day of days; track day; let index = $index) {
      <div
        data-id="range-picker-day"
        [ngClass]="{
          'in-range': day.inRange,
          padding: index % daysOfWeek.length,
          'selected-end':
            day.selected && days[index - 1]
              ? days[index - 1].inRange || days[index - 1].selected
              : false,
        }"
        class="d-flex align-items-center justify-content-center"
      >
        <div
          [ngClass]="{
            disabled: day.disabled,
            selected: day.selected,
            'in-range': day.inRange,
            'cursor-pointer': !day.disabled,
          }"
          class="d-flex align-items-center justify-content-center range-picker-calendar-cell"
          (click)="selectDate.emit(day)"
        >
          <p data-id="range-picker-day-date">{{ day.date ? day.date : '' }}</p>
        </div>
      </div>
    }
  </div>
</div>
